import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd1c455"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.field.params.type === 'header')
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_ctx.field.params?.label), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.field.params?.label), 1))
  ]))
}